var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      attrs: {
        href: `https://movix.brightfish.be/movies/${_vm.id}/edit`,
        target: "_blank",
        rel: "noopener",
      },
    },
    [_vm._v(_vm._s(_vm.title || _vm.id))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }